import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PageError from './PageError'
import { notifyError } from '../utils/appToasts'

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    notifyError('Интерфейс не смог отобразить страницу. Обновите страницу или повторите позже.')
  }

  render() {
    if (this.state.error) {
      return (
        <PageError
          error={this.state.error}
          fallback="Интерфейс не смог отобразить страницу."
          onRetry={() => window.location.reload()}
          className="m-3"
        />
      )
    }

    return this.props.children
  }
}

AppErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AppErrorBoundary
